import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Location, LocationType } from '../../../@posturinn/client-react';
import { removeSuffix } from '../../../helpers/stringHelpers/stringHelpers';
import { H6 } from '../../base/typography';
import * as StyledLocationCard from './locationCard.styles';

interface FallbackImages {
	[key: string]: string;
}

interface Props {
	location: Location;
	setSelectedLocation: any;
	fallbackImages: FallbackImages;
	highlighted?: boolean;
}

const locationStaticFallbackImage = locationType => {
	if (locationType === LocationType.PostOffice) return `/images/locations/postoffice.jpg`;
	if (locationType === LocationType.ParcelPoint) return `/images/locations/parcelpoint.jpg`;
	return `/images/locations/parcellocker.jpg`;
};

const LocationCard: FC<Props> = ({ location, setSelectedLocation, fallbackImages, highlighted }) => {
	const { t } = useTranslation('openingHours');
	const locationId = removeSuffix(location.id, 'IS');

	return (
		<StyledLocationCard.Wrapper
			data-locationid={locationId}
			$highlighted={highlighted}
			onClick={() => setSelectedLocation(location)}>
			<StyledLocationCard.LocationImage
				data-locationid={locationId}
				src={
					location.imageURL ||
					fallbackImages[location.locationType] ||
					locationStaticFallbackImage(location.locationType)
				}
				alt={location.name}
				hidePlaceholder
			/>
			<StyledLocationCard.TextContainer>
				<StyledLocationCard.InfoHeading>{location.name}</StyledLocationCard.InfoHeading>
				<StyledLocationCard.Text>{location.address.street1}</StyledLocationCard.Text>
				<StyledLocationCard.Text>
					{location.address.postalCode} {location.address.city}
				</StyledLocationCard.Text>
				{location.locationType === LocationType.PostOffice && (
					<>
						<StyledLocationCard.Text>{`${t('postoffice-card.phone')} 5801000`}</StyledLocationCard.Text>
						<StyledLocationCard.Text>
							{`${t('postoffice-card.email')} `}
							<StyledLocationCard.Email href="mailto:posturinn@posturinn.is">
								posturinn@posturinn.is
							</StyledLocationCard.Email>
						</StyledLocationCard.Text>
					</>
				)}
			</StyledLocationCard.TextContainer>
			<StyledLocationCard.OpeningHours>
				<H6 marginBottom="1rem">{`${t('postoffice-card.opening-hours')}`}</H6>
				<StyledLocationCard.Text>{`${location.statusMessage}`}</StyledLocationCard.Text>
			</StyledLocationCard.OpeningHours>
		</StyledLocationCard.Wrapper>
	);
};

export default LocationCard;
